export default __webpack_public_path__ + "static/media/email-revenue.59d011bd.svg";